/**
 * Recaptcha actions.
 * @module actions/recaptcha
 */
export const GET_RECAPTCHA = 'GET_RECAPTCHA';

/**
 * Get recaptcha.
 * @function getRecaptcha
 * @returns {Object} Get recaptcha action.
 */
export function getRecaptcha() {
  return {
    type: GET_RECAPTCHA,
    request: {
      op: 'get',
      path: `/@recaptcha`,
    },
  };
}
